import { render, staticRenderFns } from "./policyCancel.vue?vue&type=template&id=3b09f32a&scoped=true"
import script from "./policyCancel.vue?vue&type=script&lang=js"
export * from "./policyCancel.vue?vue&type=script&lang=js"
import style0 from "./policyCancel.vue?vue&type=style&index=0&id=3b09f32a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b09f32a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b09f32a')) {
      api.createRecord('3b09f32a', component.options)
    } else {
      api.reload('3b09f32a', component.options)
    }
    module.hot.accept("./policyCancel.vue?vue&type=template&id=3b09f32a&scoped=true", function () {
      api.rerender('3b09f32a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/configure/components/policyCancel.vue"
export default component.exports